<app-search-progress-linear [type]="'line'"/>
@if (shouldShowFilters) {
    <app-hotel-tours-filters/>
}
@if (!isFindTours && searchIsDone) {
    <app-tours-not-found></app-tours-not-found>
} @else {

    @for (tour of visibleTours; track tour.id) {
        <app-hotel-tour [tour]="tour"></app-hotel-tour>
    }

    @if (remainingToursCount > 0) {
        <button type="button" class="show-more-tours-btn" (click)="showAll()">
            {{ showMoreLabel }}
        </button>
    }

    @if (!isFindTours && !searchIsDone) {
        <app-hotel-tour-skeleton></app-hotel-tour-skeleton>
        <app-hotel-tour-skeleton></app-hotel-tour-skeleton>
        <app-hotel-tour-skeleton></app-hotel-tour-skeleton>
    }
}
